import React from "react";
import {
  Box,
  TextField,
  InputAdornment,
  Typography,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const FilterMotion = ({
  search,
  setSearch,
  origenFilter,
  setOrigenFilter,
  dateFrom,
  setDateFrom,
  dateTo,
  setDateTo,
}) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 3,
          flexWrap: "wrap",
          mb: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography sx={{ fontWeight: 700, color: "#424242" }}>
            Tipo de documento
          </Typography>
          <FormControl sx={{ minWidth: 260 }}>
            <Select
              value={origenFilter}
              onChange={(e) => setOrigenFilter(e.target.value)}
              displayEmpty
            >
              <MenuItem value="TODOS">Todos</MenuItem>
              <MenuItem value="COMPRA">Compra</MenuItem>
              <MenuItem value="VENTA">Venta</MenuItem>
              <MenuItem value="INVENTARIO_ING">Ingreso Inventario</MenuItem>
              <MenuItem value="INVENTARIO_EGR">Salida Inventario</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography sx={{ fontWeight: 700, color: "#424242" }}>
            Desde
          </Typography>
          <TextField
            type="date"
            value={dateFrom}
            onChange={(e) => setDateFrom(e.target.value)}
            sx={{ minWidth: 160 }}
            InputLabelProps={{ shrink: true }}
          />
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography sx={{ fontWeight: 700, color: "#424242" }}>
            Hasta
          </Typography>
          <TextField
            type="date"
            value={dateTo}
            onChange={(e) => setDateTo(e.target.value)}
            sx={{ minWidth: 160 }}
            InputLabelProps={{ shrink: true }}
          />
        </Box>
      </Box>

      <TextField
        fullWidth
        placeholder="Buscar por código, descripción, responsable o fecha"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

export default FilterMotion;
